import { buildPrompt } from '@/ai/utils/promptBuilder'
import { createUserMessage } from '@/ai/utils/promptUtils'
import { readModelNotes } from '@/ai/prompts/common/instructions'
import { examples, getEventExample } from '@/ai/prompts/common/examples'
import { getJsonArrayOutputFormatting } from '@/ai/prompts/common/formatting'

export const buildWorkflowReadModelsPrompt = ({ workflow, cardTypes }) => {
  const messages = []
  const promptSections = []

  promptSections.push({
    title: 'Request',
    content: `
      For each step, generate a Read Model (or Query Model) for the actor (human or system) about to make the
      necessary decisions to take action and complete the step. The purpose of the Read Model (or Query Model)
      is to define a query (for one or many items) that displays the current system state in a way that is relevant
      to the actor BEFORE doing the task at hand. Provide the Read Model as a set of data fields to be displayed
      to the actor BEFORE invoking the current step command the aggregate root. Usually, between 2 and 8 fields are
      sufficient, but it can be more or less. Tag each data field with INDEXED if it should be indexed
      for filtering or search. An attribute can be a primitive or a reference to a non-primitive type like
      an associated entity. An attribute or field name must be at most 30 characters long.
    `
  })

  promptSections.push({
    title: 'Note',
    contentType: 'bullet',
    content: readModelNotes
  })

  const formattingContent = `The resulting array must contain ${workflow.eventsJson.length} items.`

  const options = {
    shouldAddCards: false,
    shouldAddDataModels: true
  }

  const exampleData1 = {
    role: 'Role description',
    description: 'Created order',
    commandExample: examples.commandExampleCreateOrder
  }
  const exampleData2 = {
    role: 'Role description',
    description: 'Resolved issue',
    commandExample: examples.commandExampleDeliverOrder
  }

  const eventsExample = [
    getEventExample(exampleData1, cardTypes, null, options),
    getEventExample(exampleData2, cardTypes, null, options)
  ]

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonArrayOutputFormatting(JSON.stringify(eventsExample), formattingContent)

  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
